export const FORM_TEXTS = {
  'bankTxnId': {
    'placeholder': 'Bank Transaction ID',
    'error': {
      'minlength': 'The Bank Transaction ID is invalid',
    },
  },
  'amount': {
    'placeholder': 'Amount Contributed',
    'error': {
      'minlength': 'The amount is invalid',
    },
  },
  'donorName': {
    'placeholder': 'Name',
    'error': {
      'minlength': 'Please enter a valid name',
      'maxlength': 'Maximum character limit exceeds',
      'pattern': 'Please enter a valid name'
    },
  },
  'donorEmail': {
    'placeholder': 'Email Address',
    'error': {
      'email': 'Please enter a valid email',
    },
  },
  'donorNumber': {
    'placeholder': 'Your Mobile Number',
  },
};
